import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum, IsOptional } from "class-validator";
import { FgStockStatus } from "./fg-stock-status.enum";

export class StockStatusRequest {
    @ApiProperty()
    stockId: number;
    @ApiProperty({enum:Object.values(FgStockStatus)})
    @IsNotEmpty()
    @IsEnum(FgStockStatus)
    status:FgStockStatus.StockOut;
    @ApiProperty()
    @IsOptional()
    updatedUser: string;
}
